/**
 * Base URL para rutas Express (/api/colivings/...).
 * En dev usamos el proxy del dev server (/api → coolliving.io en vue.config.js).
 */
export function getColivingsApiBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  const configured = process.env.VUE_APP_API_URL;
  if (!configured) return '/api';
  return configured.replace(/\/$/, '');
}

const RETRYABLE_SEARCH_STATUSES = new Set([500, 502, 503, 504]);

/** Una reintento ante cold start / errores transitorios en Cloud Functions. */
export async function getSearchPropertiesWithRetry(axios, apiUrl, config) {
  try {
    return await axios.get(apiUrl, config);
  } catch (err) {
    const status = err?.response?.status;
    const isTimeout = err?.code === 'ECONNABORTED';
    if (!RETRYABLE_SEARCH_STATUSES.has(status) && !isTimeout) throw err;
    await new Promise((r) => setTimeout(r, 1800));
    return axios.get(apiUrl, config);
  }
}
